import { BaseConnector } from './baseConnector';

class NotificationConnector extends BaseConnector {
  getInvitationNotifications(hearingId) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/invitationNotifications`;
    return this.authFetch(url);
  }

  sendNotification(hearingId, notificationType) {
    var url = `${this.baseApiUrl}/hearing/${hearingId}/notification/${notificationType}/send`;
    return this.authPost(url);
  }
}

export { NotificationConnector };
